<div class="sidenav-content copo-datacenter-sidenav-content" @routeAnimation>
	<div class="copo-datacenter-flex-box">
		<div class="header-container">
			<button (click)="back()" class="back-button-icon" type="button" mat-icon-button>
				<mat-icon svgIcon="md:chevron_left"></mat-icon>
			</button>
			<span class="back-button-title">{{ headerName }}</span>
		</div>
		<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" #tabGroup>
			<mat-tab class="tab-visible" [label]="filterLabel">
				<copo-product-list-filter-customization
					class="filter-container"
					[allFilters]="allFilters"
					[addedFilters]="addedFilters"
					[additionalInput]="getAdditionalInput()"
					></copo-product-list-filter-customization>
			</mat-tab>
			<mat-tab [label]="layoutLabel">
				<copo-product-list-save-layout [class.tab-no-display]="typeOfTab==='sorting'"
											(typeOfTab)="setToggle($event)"
											(togglePositionChange)="setTogglePosition($event)"
											(currentColumnStateForSorting)="setColumn($event)"
											[togglePosition]="togglePosition"
											#layoutView></copo-product-list-save-layout>
				<copo-product-list-sorting  [class.tab-no-display]="typeOfTab==='layout'"
										(typeOfTab)="setToggle($event)"
										(togglePositionChange)="setTogglePosition($event)"
										[currentColumnStateForSorting]="currentColumnStateForSorting"
										[togglePosition]="togglePosition"
										#sortingView></copo-product-list-sorting>
			</mat-tab>
		</mat-tab-group>
		<div class="footer-container">
			<button type="button" [class.button-disabled]="!this.isValid" [disabled]="!this.isValid" class="apply-button" cdkFocusInitial
					mat-raised-button color="primary" (click)="setCurrentView()">
				<span translate>datacenter.apply</span>
			</button>
		</div>
	</div>
</div>
